module.exports = __webpack_public_path__ + "static/media/7_Peace of mind_UAE.29bd799e.txt";